<template>
    <header class="header fixed-top">
        <nav>
            <router-link to="/dashboard" class="logo"><img src="../../../img/id-plein.png" alt="logo"/></router-link>
            <!-- Sidebar toggle button-->
            <div v-if="$hasRole('super_admin') || $hasType('id_employee')"
                 class="float-left global-search--container"
                 :class="{'faded-background': query !== ''}"
                 v-click-outside="clearSearch"
            >
                <div class="global-search--dropdown">
                    <input
                        type="text"
                        v-model="query"
                        :placeholder="uLang('app.search')"
                        @keyup="onInputChange"
                        class="global-search--input"
                        autofocus
                    >
                    <div class="global-search--results">
                        <b-dropdown-header
                            v-for="(value, resourceName) in data"
                            :key="resourceName"
                            exact
                        >
                            <h4 class="global-search--name">{{ uLang(`app.${ resourceName }`) }}</h4>
                            <b-dropdown-item
                                v-for="(item, itemKey) in data[resourceName]"
                                :key="itemKey"
                                class="dropdown_content"
                                exact
                            >
                                <component
                                    :is="resourceName + '-result'"
                                    :resource="item"
                                    :resourceName="resourceName"
                                    class="global-search--result"
                                    @redirect="redirectToResource"
                                />
                            </b-dropdown-item>
                        </b-dropdown-header>
                    </div>
                </div>
            </div>
            <div class="navbar-right">

                <!--drop downs-->
                <div>
                    <!-- User Account: style can be found in dropdown-->
                    <b-dropdown class="user user-menu" right link>
                    <span slot="text">
                        <img :src="imagePath" class="rounded-circle" alt="User Image">
                        <!-- User name-->
                        <p class="user_name_max">{{ user.name }}</p>
                    </span>
                        <b-dropdown-item exact class="dropdown_content">
                            <router-link :to="profileUrl" exact class="dropdown-text">
                                <i class="fa fa-user"></i> {{ uLang('app.my_profile') }}
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item exact class="dropdown_content">
                            <a class="dropdown-text" @click.prevent="logout">
                                <i class="fa fa-sign-out"></i> {{ uLang('app.logout') }}
                            </a>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </nav>
    </header>
</template>
<script>
    import trajectoriesResult from "~/components/searchresult/trajectories-result";
    import trajectoryEnrolmentsResult from "~/components/searchresult/trajectory-enrolments-result";
    import relationsResult from "~/components/searchresult/relations-result";
    import router from '~/router'
    import { mapGetters } from 'vuex'

    export default {
        name: "vueadmin_header",
        components: {
            trajectoriesResult,
            trajectoryEnrolmentsResult,
            relationsResult
        },
        computed: {
            ...mapGetters({
                user: 'authUser'
            }),
            imagePath() {
                if (!this.user || !this.user.image_id) {
                    return this.profileImagePath;
                }

                return route("resource.files.show", {file: this.user.image_id});
            },
            profileUrl() {
                return '/admin/relations/my-profile'
            }
        },

        data() {
            return {
                query: '',
                params: {
                    resources: [
                        'trajectories',
                        'trajectory-enrolments',
                        'relations'
                    ]
                },
                data: {},
                profileImagePath: '/images/login_user-01.png',
            }
        },

        methods: {
            clearSearch() {
                this.query = ''
                this.data = {}
            },
            async logout() {
                await this.$store.dispatch('logout');
                this.$router.push({ name: 'login' });
            },
            onInputChange(event) {
                if (event.key === 'ArrowDown') {
                    return;
                }

                this.data = {};

                if (this.query.length < 2) {
                    return;
                }

                this.search();
            },
            redirectToResource(request) {
                this.data = {}
                this.query = ""
                router.push({
                    name: request.routeName,
                    params: request.params
                })
            },
            async search() {
                let url = route('search', { query: this.query }) + '?' + this.queryParams(this.params);

                await window.axios.get(url).then(({ data }) => {
                    this.data = data;
                })
            },
            queryParams(source) {
                let array = [];

                for (let key in source) {
                    array.push(encodeURIComponent(key) + "=" + encodeURIComponent(source[key]));
                }

                return array.join("&");
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../css/customvariables";
    .header {
        z-index: 1030;
        nav {
            margin-bottom: 0;
            height: 50px;
            background: $header_color;
            background-size: 100% 100%;
            box-shadow: 0px 0px 10px #ccc;
        }
        .navbar-right {
            float: right;
            margin-right: 15px;
        }
        .logo {
            display: block;
            float: left;
            height: 50px;
            line-height: 41px;
            padding: 3px 10px;
            text-align: center;
            width: 250px;
            background: $header_color;
            img {
                max-width: 100%;
                max-height: 50px;
                padding-bottom: 3px;
            }
        }
        .navbar-right {
            .dropdown-item {
                padding: 0;
                width: 100%;
                outline: none;
            }
            div.dropdown {
                > a {
                    color: $zoom_color;
                }
                .dropdown-menu > button {
                    padding: 10px 15px;
                }
                &.notifications-menu {
                    height: 50px;
                    .noti-icon {
                        font-size: 18px;
                    }
                }
                > a > i {
                    font-size: 20px;
                }
                > a {
                    display: block;
                    padding: 12px;
                }
                &:hover > a {
                    background-color: #ededed;
                    color: #000;
                }
                > a.padding-user {
                    padding-top: 8px;
                    padding-bottom: 6px;
                }
            }
        }

        nav .sidebar-toggle {
            float: left;
            color: $toggle_color;
            font-size: 19px;
            padding-top: 10px;
        }
    }

    .user_name_max {
        display: inline-block;
        max-width: 180px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        margin: 0 0 -4px;
    }

    .noti_msg {
        font-size: 16px;
        padding: 10px;
        border: 1px solid #4f90c1;
        border-radius: 50px;
        margin-top: 10px;
    }

    .user.user-menu > button img {
        width: 35px;
        height: 35px;
    }

    .faded-background {
        outline: 2000px solid #aaaaaa55;
    }

    .global-search {
        &--container {
            margin-left: 2rem;
        }

        &--dropdown {
            background: #ffffff;
            width: 60rem;
        }

        &--input {
            width: 60rem;
            height: 4rem;
            margin: 0.1rem;
            border: none;
            position: sticky;
            top: 0;
        }

        &--results {
            z-index: 9999;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 90vh;
        }

        &--name {
            color: #c10f6d;
        }

        &--result {
            font-size: 14px;
            margin-bottom: 0.15rem;
            padding-top: 0.25rem;
            border-bottom: 1px rgba(150, 150, 150, 0.2) solid;

            &:hover {
                border-bottom: 1px #5c478b66 solid;
            }
        }
    }

    /**** END HEADER RIGHT SIDE DROPDOWNS ****/

    @media screen and (min-width: 992px) {
        .sidebar-toggle {
            //display: none;
        }
    }

    @media screen and (max-width: 1103px) {
        .global-search--container {
            display: none;
        }
    }

    @media screen and (max-width: 767px) {
        .dropdown.open .dropdown-menu {
            position: absolute;
        }
        .navbar-right > li > a {
            padding: 10px 12px;
        }
    }


    /* Fix menu positions on xs screens to appear correctly and fully */

    @media (max-width: 560px) {
        body .header .logo,
        body .header nav {
            width: 100%;
        }
        body .header nav .sidebar-toggle {
            padding-left: 15px;
        }
        nav {
            height: 100px !important;
        }
    }

    .notifications_badge_top {
        margin-top: -28px;
        margin-left: 10px;
        position: absolute;
        span {
            top: 1px;
            left: 2px;
            border-radius: 50%;
        }
    }

    .notifications-menu .dropdown-item {
        width: 100%;
        display: block;
    }

    .dropdown-footer {
        padding: 10px !important;
    }
</style>
<style type="text/css" lang="scss">
    .wrapper {
        margin-top: 50px;
        @media screen and (max-width: 560px) {
            margin-top: 100px;
        }
    }
    .sidebar-toggle {
        margin-left: 10px;
    }

</style>
